import { encodeAbiParameters, getCreate2Address, isAddress, keccak256 } from 'viem';

import { SAFE_FACTORY_ADDRESS, SAFE_INIT_CODE_HASH } from '@/constants/tokens.constants';

/**
 * Derives the Gnosis Safe proxy address for a given EOA owner and factory.
 * Replicates the internal logic of the Polymarket Relayer SDK to avoid export issues.
 *
 * @param address - EOA owner address
 * @param safeFactory - Polymarket Safe Factory address (defaults to official SDK one)
 */
export const deriveSafe = (address: string, safeFactory: string = SAFE_FACTORY_ADDRESS) => {
  if (!address || !isAddress(address)) return undefined;

  try {
    return getCreate2Address({
      bytecodeHash: SAFE_INIT_CODE_HASH,
      from: safeFactory as `0x${string}`,
      salt: keccak256(
        encodeAbiParameters([{ name: 'address', type: 'address' }], [address as `0x${string}`])
      ),
    });
  } catch (err) {
    console.error('[deriveSafe] Failed to derive address:', err);
    return undefined;
  }
};
